"use client"

import styles from "./Checkbox.module.css"

const Checkbox = ({ checked = false, onChange, label, disabled = false, indeterminate = false, ...props }) => {
  const handleChange = (e) => {
    if (disabled) return
    if (onChange) onChange(e.target.checked)
  }

  const checkboxClasses = [
    styles.checkbox,
    checked && styles.checked,
    disabled && styles.disabled,
    indeterminate && styles.indeterminate,
  ]
    .filter(Boolean)
    .join(" ")

  return (
    <label className={styles.container}>
      <input
        type="checkbox"
        className={styles.hiddenInput}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        {...props}
      />
      <div className={checkboxClasses}>
        {indeterminate ? (
          <span className={styles.indeterminateIcon}>−</span>
        ) : checked ? (
          <span className={styles.checkIcon}>✓</span>
        ) : null}
      </div>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  )
}

export default Checkbox
